module.exports = __webpack_public_path__ + "img/foto8.ac8da7aa.jpg";